import api from './api';

// Studio Editor — generation only. Listing, download, print / download tracking, rename and delete of a studio photo go through the
// shared image endpoints (imageGenerationService, source 'studio', ids like "s12").
const studioEditorService = {
    // Edit one photo (multipart) → { id: 's12', aiImage, uploadedImage, background, photoSize, peopleCount, timestamp }
    generate: async (formData) => {
        const response = await api.post('/api/studio-editor/generate', formData, {
            timeout: 120000, // 2 minutes — the model call takes a while
        });
        return response;
    },
};

export default studioEditorService;
